import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6224a58a&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VApp,VBanner,VMain,VSlideXReverseTransition})
